// +-------------------------------------------------------------
// | Created by WebStorm.
// +-------------------------------------------------------------
// | User: msmile
// +-------------------------------------------------------------
// | Date: 2025/5/23
// +-------------------------------------------------------------
// |Time: 11:17
// +-------------------------------------------------------------
export default [
    {
        path: '/goods/goods-detail/:ids',
        name: 'GoodsDetail',
        component: () => import('@/views/Goods/GoodsDetail/Index.vue'),
        meta: {title: '游戏详情'},
    },
]